import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {Router} from '@angular/router';
import {DateTime} from 'luxon';

import {FacultyNotification} from 'libs/data-access/notification/src/lib/models/request-response-notification.models';
import {generateHumanizedDate} from 'libs/shared/util/src/lib/_helpers/date-helper';

@Component({
    selector: 'lib-faculty-bulk-import-complete',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './faculty-bulk-import-complete.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacultyBulkImportCompleteComponent {
    readonly notification = input<FacultyNotification>();
    readonly notificationRead = output<void>();
    condensedView = input(false);

    readonly router = inject(Router);

    readonly date = computed(() => {
        const notification = this.notification();
        return generateHumanizedDate(notification.AvailableDate ?? DateTime.now());
    });

    viewImportHistory(bulkImportId: number): void {
        this.notificationRead.emit();
        this.router.navigateByUrl(`/manage/faculty/import-history/${bulkImportId}`);
    }

    getFacultyWord: (count: number) => string = (count) => (count > 1 ? 'faculties' : 'faculty');
    getCompletionVerb: (count: number) => string = (count) => (count > 1 ? 'were' : 'was');
}
